import { graphql } from '../../gql';
export const VAGO_FORCE_RE_RATE = graphql(`
  mutation MyMutation($token: String!, $uniqueId: String!) {
    vagoForceReRate(token: $token, uniqueId: $uniqueId) {
      ok
    }
  }
`);
